export default "__VITE_ASSET__wKPqqpPC__"